import AccountForm from 'common/pages/account/AccountForm.tsx'

export const AccountFormAdmin = (props: any) => <AccountForm {...props} mode={props.mode} admin/>